"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var SelectInput = function (props) {
    var _a;
    return (props.isEditing ?
        (react_1.default.createElement(material_1.FormControl, { variant: "standard", fullWidth: true, error: props.error, sx: { marginTop: 0, marginBottom: 2 }, required: props.required },
            react_1.default.createElement(material_1.InputLabel, { id: "select-".concat(props.label) }, props.label),
            react_1.default.createElement(material_1.Select, { autoFocus: props.autoFocus, labelId: "select-".concat(props.label), value: props.value, name: props.name, required: props.required, onChange: props.onChange, onBlur: props.onBlur, label: props.label, input: react_1.default.createElement(StyledInput, null) },
                props.showNone &&
                    react_1.default.createElement(material_1.MenuItem, { value: "" },
                        react_1.default.createElement("em", null, "None")),
                props.options.map(function (option) { return (react_1.default.createElement(material_1.MenuItem, { value: option.value, key: "select-option-".concat(props.name, "-").concat(option.value) }, option.label)); })),
            props.helperText &&
                react_1.default.createElement(material_1.FormHelperText, { error: props.error, sx: { marginBottom: -2 } }, props.helperText)))
        :
            (react_1.default.createElement(material_1.FormControl, { sx: { minHeight: '50px' } },
                react_1.default.createElement(material_1.Typography, { variant: "overline", display: "block" }, props.label),
                react_1.default.createElement("span", null, (_a = props.options.find(function (o) { return o.value === props.value; })) === null || _a === void 0 ? void 0 : _a.label))));
};
// This will fix the inconsistent spacing with the Select component vs TextInput
var StyledInput = (0, material_1.styled)(material_1.Input)(function () { return ({
    'label + &': {
        marginTop: '14px',
    },
}); });
exports.default = SelectInput;
